export enum MessageContentType {
	UndefinedCaptionObject = 'undefinedCaptionObject',
	UndefinedCaptionText = 'undefinedCaption',
	EmptyCaptionText = 'emptyCaption',
	UndefinedCaptionType = 'undefinedCaptionType',
	IncorrectCaptionType = 'incorrectCaptionType',
}
